import { Loader2 } from 'lucide-react';

interface CompaniesFavoriteCountProps {
  count: number;
  isLoading?: boolean;
}

export default function CompaniesFavoriteCount({
  count,
  isLoading = false,
}: CompaniesFavoriteCountProps) {
  if (!isLoading && count === 0) {
    return null;
  }

  return (
    <div
      className="flex items-center justify-center"
      role="status"
      aria-live="polite"
      aria-busy={isLoading}
    >
      {isLoading ? (
        <div className="flex items-center gap-2.5">
          <Loader2 className="h-4 w-4 animate-spin text-emerald-600" aria-hidden="true" />
          <span className="text-sm font-semibold text-gray-500">Loading favorites…</span>
        </div>
      ) : (
        <div
          className="flex items-center gap-1.5"
          aria-label={`${count} ${count === 1 ? 'company' : 'companies'}`}
        >
          <span className="rounded-full bg-emerald-700 px-2 py-0.5 text-xs font-semibold tabular-nums text-white">
            {count}
          </span>
          <span className="text-xs font-semibold text-emerald-700">companies</span>
        </div>
      )}
    </div>
  );
}
